import {
  spotlightAbTestVariantSchema,
  spotlightDeviceTarget,
  SpotlightTriggerType,
} from "@redotech/redo-spotlight-common/spotlight-schema";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const createSpotlightSplit = {
  name: "createSpotlightSplit" as const,
  input: z.object({
    name: z.string().min(1, "Test name is required"),
    deviceTarget: createEnum(spotlightDeviceTarget),
    triggerType: createEnum(SpotlightTriggerType),
    variants: z
      .array(spotlightAbTestVariantSchema)
      .min(2, "At least 2 variants required"),
  }),
  output: z.object({ splitId: zExt.objectId() }),
};
